module.exports = __webpack_public_path__ + "img/info_warning.c675ac64.png";